export const getMaNavigation = (state) => state.maNavigation;
export const getProfileLinkTemplate = (state) => getMaNavigation(state).profileLinkTemplate;
export const getSettingsLink = (state) => getMaNavigation(state).settingsLink;
export const getNotificationsLink = (state) => getMaNavigation(state).notificationsLink;
export const getIsNavigationAllowed = (state) => getMaNavigation(state).isNavigationAllowed;
